import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { CircularProgress } from '@mui/material';
import { collection, query, where, getDocs } from "firebase/firestore";
import { firestore } from './firebase';
import "firebase/auth";
import "firebase/firestore";

const SubVerification = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const auth = getAuth();

    const handleNav = () => {
        navigate('/onboarding');
    };

    useEffect(() => {
        const authSubscriber = onAuthStateChanged(auth, setUser);
        return authSubscriber;
    }, []);
    useEffect(() => {
        if (user) {
            const intervalId = setInterval(async () => {
                console.log("c:c");
                const q = query(collection(firestore, "payments"), where("user", "==", user.email));
                const querySnapshot = await getDocs(q);
                if (!querySnapshot.empty) {
                    handleNav();
                }
            }, 2000);
            try {
                window.uetq = window.uetq || [];
                window.uetq.push('set', {
                    'pid': {
                        'em': user.email,
                        'ph': ""
                    }
                });
            } catch (e) {
                console.error(e);
            }

            return () => clearInterval(intervalId);
        }
    }, [firestore, user]);

    useEffect(() => {
        if (window._tfa) {
            console.log("Sending conversion event");
            window._tfa.push({ notify: 'event', name: 'conversion', id: 1768835 });
        }
        if (window.rdt) {
            window.rdt('track', 'Purchase');
        }

        // New gtag Conversion Event with Default Values
        if (window.gtag) {
            if (window.__trackerRan) return;
            window.__trackerRan = true;
            console.log("Sending gtag conversion event with default values");
            window.gtag('event', 'conversion', {
                'send_to': 'AW-16783644331/byqgCOamg-wZEKutiMM-',
                'value': 10, // Default value
                'currency': 'USD', // Default currency
            });
        } else {
            console.warn("gtag function not found");
        }
        if (window.twq) {
            if (window.__twitterTrackerRan) return;
            window.__twitterTrackerRan = true;
            window.twq('event', 'tw-pph2h-pph3f', {});
        } else {
            console.warn('Twitter tracking script not loaded');
        }
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
        }}>
            <h3 style={{ marginBottom: '12px' }}>
                Verifying Bullflow Subscription. You will be redirected to the dashboard...
            </h3>
            <button
                onClick={handleNav}
                style={{
                    marginBottom: '12px',
                    padding: '8px 16px',
                    fontSize: '16px',
                    cursor: 'pointer'
                }}
            >
                If you are not redirected in a few seconds, click here
            </button>
            <CircularProgress />
        </div>
    );
}

export default SubVerification;
